import Vue from 'vue';

import { UiIcon } from '../ui';

Vue.component('UiIcon', UiIcon);
